import React from 'react';
import FontAwesome from 'react-fontawesome';
import { NavLink } from 'react-router-dom';

import EmailForm from 'components/global/application/EmailForm';
import Carousel from 'containers/global/application/Carousel';
import CarouselSlide from './CarouselSlide';

import whiteLogo from 'assets/images/website-logo-white.png';
import { BREAK_POINT } from 'constants/responsive';

import './Footer.sass';

const footerSlideTextItems: {bold: string, sub: string, link: string}[] = [
    {
        bold: 'EXPERT INSPECTIONS AND REPAIR',
        link: '/repair-shop/',
        sub: 'Our staff of eight repairmen sees that all instruments are properly restored and set up in optimum playing order including set-up.'
    },
    {
        bold: 'ACCURATE DESCRIPTIONS',
        link: '/appraisals/',
        sub: 'Instruments are personally described by George Gruhn. We take pride in providing accurate representations of age, condition and originality'
    },
    {
        bold: 'CERTIFICATION',
        link: '/appraisals/',
        sub: 'With our written appraisal - free upon request with every instrument we sell - we authenticate and value your instrument',
    }
];

interface State {
    showNewsLetterSignup: boolean;
}

class Footer extends React.Component<{}, State> {
    constructor(props: any) {
        super(props);

        this.state = { showNewsLetterSignup: false };
        this.newsLetterShowToggle = this.newsLetterShowToggle.bind(this);
    }

    public componentDidUpdate() {
        if (typeof (window as any).affirm.ui.refresh === 'function') {
            (window as any).affirm.ui.refresh();
        }
    }

    public newsLetterShowToggle = () => {
        this.setState({ showNewsLetterSignup: !this.state.showNewsLetterSignup });
    }

    public render() {
        return window.innerWidth < BREAK_POINT ? this.mobile() : this.desktop();
    }

    private affirmLogo() {
        const affirmAttributes = {
            className: 'affirm-site-modal',
            'data-page-type': 'homepage'
        };

        return  (<a style={{ marginTop: '25px' }} {...affirmAttributes}><img src="https://cdn-assets.affirm.com/images/white_logo-transparent_bg.png" width="200"/></a>);
    }

    private mobile() {
        return(
            <div className="App-footer-mobile">
                <EmailForm isOpen={this.state.showNewsLetterSignup} onRequestClose={this.newsLetterShowToggle} isMobile={true} />
                <div className="row App-footer-carousel">
                    <Carousel name="footer-carousel">
                        {footerSlideTextItems.map(v => <CarouselSlide
                            key={v.bold}
                            bold_text={v.bold}
                            sub_text={v.sub}
                            link={v.link}
                        />)}
                    </Carousel>
                </div>
                <div className="row text-center App-footer-content">
                    <div className="offset-2 col-8">
                        <img className="logo img-responsive" src={whiteLogo} />
                        <span>2120 8th Av S</span>
                        <span>Nashville, TN 37204</span>
                        <span><NavLink className="Link" exact to="/contactdirections/">Directions</NavLink></span>
                        <br />
                        <span>Monday - Saturday 10:00a - 6:00p</span>
                        <span>Closed Sundays</span>
                        <span><NavLink className="Link" exact to="/holidayschedule/">Holiday Schedule</NavLink></span>
                        <br />
                        <span><a href="tel:615-256-2033">P | 615.256.2033</a></span>
                        <span><a href="tel:615-255-2021">F | 615.255.2021</a></span>
                        <span><a href="mailto:gruhn@gruhn.com">Email: gruhn@gruhn.com</a></span>
                        <br />
                        <span className="Copyright">&copy; {new Date().getFullYear()} Gruhn Guitars All rights reserved</span>

                        {this.affirmLogo()}

                        <a style={{ marginTop: '20px' }} onClick={this.newsLetterShowToggle}>Sign up here to receive new inventory updates</a>
                    </div>
                </div>
                <NavLink className="row text-center App-footer-contact" to="/contactdirections/">Contact Us</NavLink>
            </div>
        );
    }

    private desktop() {
        return(
            <div className="App-footer">
                <EmailForm isOpen={this.state.showNewsLetterSignup} onRequestClose={this.newsLetterShowToggle} isMobile={false} />
                <div className="row App-footer-guarantees">
                    <div className="offset-1 col-10">
                        <div className="row">
                            {footerSlideTextItems.map((v, i) => <CarouselSlide
                                key={v.bold}
                                bold_text={v.bold}
                                sub_text={v.sub}
                                className="col-4"
                                link={v.link}
                            />)}
                        </div>
                    </div>
                </div>
                <div className="row App-footer-image">
                    <div className="offset-1 col-3">
                        <img className="logo img-responsive" src={whiteLogo} />
                    </div>
                </div>
                <div className="row App-footer-content">
                    <div className="offset-1 col-4">
                        <div className="text-left Under-image">
                            <span>2120 8th Av S</span>
                            <span>Nashville, TN 37204</span>
                            <span><NavLink exact to="/contactdirections/">Directions</NavLink></span>
                            <br />
                            <span>Monday - Saturday 10:00a - 6:00p</span>
                            <span>Closed Sundays</span>
                            <span><NavLink exact to="/holidayschedule/">Holiday Schedule</NavLink></span>
                            <br />
                            <span><a href="tel:615-256-2033">P | 615.256.2033</a></span>
                            <span><a href="tel:615-255-2021">F | 615.255.2021</a></span>
                            <span><a href="mailto:gruhn@gruhn.com">Email: gruhn@gruhn.com</a></span>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="text-left Middle-content">
                            <span className="Header-item">Links</span>
                            <NavLink exact to="/gruhn-guitars-story/">Our Story</NavLink>
                            <NavLink exact to="/users/george/">George Gruhn</NavLink>
                            <NavLink exact to="/gruhn-guitars-staff/">Staff</NavLink>
                            <NavLink exact to="/repair-shop/">Repair Shop</NavLink>
                            <NavLink exact to="/store-tour/">Online Tour</NavLink>
                            <NavLink exact to="/want-file/">Want File</NavLink>
                            <NavLink exact to="/store-policies/">Store Policies</NavLink>
                            <NavLink exact to="/privacy-policy/">Privacy Policy</NavLink>
                            <NavLink exact to="/terms-use/">Terms of Use</NavLink>
                            <NavLink exact to="/contactdirections/">Contact Us</NavLink>
                        </div>
                    </div>
                    <div className="col-3 Right-content">
                        <span className="Header-item">Connect with Us</span>
                        <a className="Social-icon-anchor" target="_blank" href="https://www.facebook.com/gruhnguitars"><FontAwesome className="Footer-icon" name="facebook-square" /></a>
                        <a className="Social-icon-anchor" target="_blank" href="https://www.instagram.com/gruhnguitars/"><FontAwesome className="Footer-icon" name="instagram" /></a>
                        <a className="Social-icon-anchor" target="_blank" href="https://twitter.com/gruhnguitars"><FontAwesome className="Footer-icon" name="twitter-square" /></a>
                        <a className="Social-icon-anchor" target="_blank" href="https://www.youtube.com/user/gruhnguitarsinc"><FontAwesome className="Footer-icon" name="youtube-play" /></a>
                        <br />
                        <br />
                        {this.affirmLogo()}
                        <a style={{ marginTop: '20px' }} onClick={this.newsLetterShowToggle} >Sign up here to receive new inventory updates</a>
                    </div>
                </div>
                <div className="row Copyright-container">
                    <span className="Copyright">© {new Date().getFullYear()} Gruhn Guitars All rights reserved</span>
                </div>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/global/application/footer/Footer.tsx